/** Una sesión por aplicación; ninguna sustituye la sesión del panel. */
import type { DirectoryMemberApp, DirectorySession } from "@shared/types";

import { pbApp, post } from "./pb";

const KEY = "plane_directorio";
let apps = $state<DirectoryMemberApp[]>(read());

function read(): DirectoryMemberApp[] {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? "null") as DirectorySession | null;
    if (!Array.isArray(saved?.apps)) return [];
    return saved.apps.filter((app) => typeof app?.token === "string" && !!app.token).slice(0, 50);
  } catch {
    return [];
  }
}

function save(next: DirectoryMemberApp[]): void {
  // Si la sesión activa acaba de caducar o perdió acceso, tampoco se conserva en pbApp.
  if (
    apps.some((app) => app.token === pbApp.authStore.token) &&
    !next.some((app) => app.token === pbApp.authStore.token)
  ) {
    pbApp.authStore.clear();
  }
  apps = next;
  try {
    if (next.length) localStorage.setItem(KEY, JSON.stringify({ apps: next }));
    else localStorage.removeItem(KEY);
  } catch {
    // Sin almacenamiento disponible, la sesión dura hasta cerrar esta página.
  }
}

export const directorySession = {
  get apps() {
    return apps;
  },
  async refresh(): Promise<void> {
    if (!apps.length) return;
    const result = await post<DirectorySession>("/api/directorio/sesion", {
      tokens: apps.map((app) => app.token),
    });
    save(result.apps);
  },
  async enter(email: string, password: string): Promise<void> {
    const result = await post<DirectorySession>("/api/directorio/entrar", { email, password });
    save(result.apps);
  },
  open(app: DirectoryMemberApp): void {
    pbApp.authStore.save(app.token, {
      ...app.member,
      app: app.id,
      collectionId: "members",
      collectionName: "members",
    });
  },
  clear(): void {
    save([]);
  },
};
